import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=709f245d&scoped=true"
import script from "./AdminMain.vue?vue&type=script&lang=ts"
export * from "./AdminMain.vue?vue&type=script&lang=ts"
import style0 from "./AdminMain.vue?vue&type=style&index=0&id=709f245d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f245d",
  null
  
)

export default component.exports